module.exports = __webpack_public_path__ + "static/icon-CB-c572e2a42d176758beeef4ac32854a22.svg";